module.exports = __webpack_public_path__ + "static/media/6.5.6094505a.zip";